import axios from "../api/axios";
import store from "../store";
import {
  telematicsRequest,
  telematicsFileRequest,
  buildQuery,
} from "./telematicsRequest";

export default {
  async execute(method, resource, data) {
    return axios
      .alertconfigEndpoint({
        method,
        url: resource,
        data,
        headers: {
          customerId:
            store.getters.companyIdDropdown == null
              ? ""
              : store.getters.companyIdDropdown,
        },
      })
      .then((req) => {
        return req.data;
      });
  },
  async executeFiles(method, resource, data) {
    return axios
      .alertconfigEndpoint({
        method,
        url: resource,
        data,
        headers: {
          customerId:
            store.getters.companyIdDropdown == null
              ? ""
              : store.getters.companyIdDropdown,
        },
        responseType: "blob",
      })
      .then((req) => {
        return req.data;
      });
  },

  // Alert firings (list, detail, export, resolve, active-by-fleet) are served by
  // birch-telematics-api, not the alerts API — the standard i5-cp-alerts-api owns
  // alert *configuration* and events only. Config CRUD below keeps using execute().
  async executeTelematics(method, resource, data) {
    return telematicsRequest(method, resource, data);
  },
  async executeTelematicsFiles(method, resource, data) {
    return telematicsFileRequest(method, resource, data);
  },

  ///////////////////Alert API ////////////////////////

  fetchEvents() {
    return this.execute("get", `/Events`);
  },
  getEventDetails(eventId) {
    return this.execute("get", `/Events/${eventId}`);
  },

  fetchAlerts(selectedStatus, pageNo = 1, pageSize = 100, sortBy = "", sortOrder = "", eventType = "") {
    let url = `/AlertConfig?status=${selectedStatus}&pageNo=${pageNo}&pageSize=${pageSize}`;
    if (sortBy) url += `&sortBy=${sortBy}&sortOrder=${sortOrder}`;
    if (eventType) url += `&eventType=${eventType}`;
    return this.execute("get", url);
  },

  fetchDtcCodes() {
    return this.execute("get", `/AlertConfig/dtccodes`);
  },

  fetchActiveAlerts(fleetId) {
    return this.executeTelematics(
      "get",
      `/Alerts/activealerts/${encodeURIComponent(fleetId)}`
    );
  },

  resolveAlert(alertConfigId) {
    return this.executeTelematics(
      "put",
      `/Alerts/${encodeURIComponent(alertConfigId)}/resolve`
    );
  },

  updateAlert(alertConfigId, data) {
    return this.execute("put", `/AlertConfig/${alertConfigId}/status`, data);
  },

  saveAlertConfiguration(data) {
    return this.execute("post", `/AlertConfig`, data);
  },
  updateAlertConfiguration(alertConfigId, payload) {
    return this.execute("put", `/AlertConfig/${alertConfigId}`, payload);
  },

  getAlertDetailsById(alertConfigId) {
    return this.execute("get", `/AlertConfig/${alertConfigId}`);
  },

  deleteAlert(alertConfigId) {
    return this.execute("delete", `/AlertConfig/${alertConfigId}`);
  },

  //my changes

  fetchAlertsData(
    fromDate,
    toDate,
    groupIds,
    jobSite,
    eventType,
    selectedSeverity,
    status,
    searchText,
    pageNumber,
    pageSize,
    sortBy,
    sortOrder
  ) {
    const query = buildQuery({
      fromDate,
      toDate,
      eventType,
      severity: selectedSeverity,
      status,
      groupIds,
      jobSite,
      searchText,
      pageNumber,
      pageSize,
      sortBy,
      sortOrder,
    });
    return this.executeTelematics("get", `/Alerts/all?${query}`);
  },
  getAlertsDataById(alert) {
    return this.executeTelematics(
      "get",
      `/Alerts/${encodeURIComponent(alert)}`
    );
  },
  getAlertsDataByIdDetails(alertConfigId) {
    return this.executeTelematics(
      "get",
      `/Alerts/${encodeURIComponent(alertConfigId)}/details`
    );
  },

  excelDownload(
    fromDate,
    toDate,
    groupIds,
    jobSite,
    eventType,
    selectedSeverity,
    status,
    searchText,
    pageNumber,
    pageSize,
    sortBy,
    sortOrder
  ) {
    const query = buildQuery({
      fromDate,
      toDate,
      eventType,
      severity: selectedSeverity,
      status,
      groupIds,
      jobSite,
      searchText,
      pageNumber,
      pageSize,
      sortBy,
      sortOrder,
    });
    return this.executeTelematicsFiles(
      "get",
      `/Alerts/exporttoexcel?${query}`,
      {
        responseType: "blob",
      }
    );
  },
  //changes
};
